/** Strategy ids excluded from MonitorScreenCalculation (lots, trades, dashboard). */
export const IGNORED_MONITOR_STRATEGY_IDS = new Set([
  "4a7bf20caf4e5affa14ff4aba23fbf31",
]);

export function isIgnoredMonitorStrategy(strategyId) {
  return IGNORED_MONITOR_STRATEGY_IDS.has(strategyId);
}
